import { render, staticRenderFns } from "./AdminViewAssignStatusOnAccountSDData.vue?vue&type=template&id=98c19cfa&scoped=true"
import script from "./AdminViewAssignStatusOnAccountSDData.vue?vue&type=script&lang=js"
export * from "./AdminViewAssignStatusOnAccountSDData.vue?vue&type=script&lang=js"
import style0 from "./AdminViewAssignStatusOnAccountSDData.vue?vue&type=style&index=0&id=98c19cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c19cfa",
  null
  
)

export default component.exports